// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { COTIZADOR_ACT_DELETE_OPTIONS } from './constants'

export function actDeleteOptions(entities) {
  return {
    type: COTIZADOR_ACT_DELETE_OPTIONS,
    args: entities,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COTIZADOR_ACT_DELETE_OPTIONS:
      let obj = {}
      action.args.forEach((element) => {
        return (obj = { ...obj, [element]: [] })
      })
      return {
        ...state,
        ...obj,
      }

    default:
      return state
  }
}
